var _marker, _marker2, _marker3, _marker4, _rect, _rect2, _text, _text2, _line, _rect3, _text3, _text4, _line2, _text5, _text6, _text7, _text8, _line3, _text9, _rect4, _text0, _text1, _text10, _line4, _circle, _text11, _circle2, _text12, _line5, _text13, _circle3, _text14, _circle4, _text15, _circle5, _text16, _line6, _text17, _path, _text18, _rect5, _text19, _text20, _text21, _line7, _circle6, _text22, _text23, _circle7, _text24, _text25, _circle8, _text26, _text27, _line8, _line9, _text28, _rect6, _text29, _text30, _line0, _circle9, _text31, _circle0, _text32, _circle1, _text33, _line1, _text34, _line10, _text35, _rect7, _text36, _text37, _line11, _circle10, _text38, _text39, _circle11, _text40, _text41, _line12, _text42, _rect8, _text43, _text44, _text45, _line13, _text46, _line14, _text47, _line15, _text48, _line16, _text49, _circle12, _text50, _circle13, _text51, _circle14, _text52;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewSentimentPipeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 500,
    viewBox: "0 0 900 500",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "ac",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#818cf8"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "ag",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#34d399"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "ap",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#a78bfa"
  }))), _marker4 || (_marker4 = /*#__PURE__*/React.createElement("marker", {
    id: "aa",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#F59E0B"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#080d1e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#030509"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 500,
    fill: "url(#bgGrad)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 500,
    fill: "none",
    rx: 12,
    stroke: "rgba(99,102,241,0.12)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 34,
    textAnchor: "middle",
    fill: "#e0e7ff",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: -0.3
  }, "AI Review Response Pipeline")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 52,
    textAnchor: "middle",
    fill: "#a5b4fc",
    fontSize: 10
  }, "Azure Cognitive Services \xB7 OpenAI API \xB7 Prompt Engineering \xB7 Sentiment Analysis")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 64,
    x2: 860,
    y2: 64,
    stroke: "rgba(99,102,241,0.1)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 148,
    width: 122,
    height: 140,
    rx: 6,
    fill: "rgba(99,102,241,0.07)",
    stroke: "#6366f1",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 79,
    y: 172,
    textAnchor: "middle",
    fill: "#818cf8",
    fontSize: 12,
    fontWeight: 700
  }, "Client")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 79,
    y: 188,
    textAnchor: "middle",
    fill: "#818cf8",
    fontSize: 12,
    fontWeight: 700
  }, "Reviews")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 196,
    x2: 128,
    y2: 196,
    stroke: "rgba(99,102,241,0.12)",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 79,
    y: 213,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "Online platform")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 79,
    y: 228,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "Incoming feedback")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 79,
    y: 248,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "Positive \xB7 Neutral")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 79,
    y: 263,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "Negative reviews")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 218,
    x2: 168,
    y2: 218,
    stroke: "#818cf8",
    strokeWidth: 1.5,
    markerEnd: "url(#ac)"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 211,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "text")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 118,
    width: 168,
    height: 200,
    rx: 6,
    fill: "rgba(56,189,248,0.06)",
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 254,
    y: 143,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 12,
    fontWeight: 700
  }, "Azure Cognitive")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 254,
    y: 159,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 12,
    fontWeight: 700
  }, "Services")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 254,
    y: 174,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "Text Analytics API")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 181,
    x2: 326,
    y2: 181,
    stroke: "rgba(56,189,248,0.1)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 199,
    r: 3,
    fill: "#818cf8",
    opacity: 0.8
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 198,
    y: 203,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "Sentiment score")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 218,
    r: 3,
    fill: "#818cf8",
    opacity: 0.8
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 198,
    y: 222,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "Confidence levels")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 232,
    x2: 326,
    y2: 232,
    stroke: "rgba(56,189,248,0.08)",
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 254,
    y: 248,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 9
  }, "Output:")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 264,
    r: 4,
    fill: "#34d399",
    opacity: 0.85
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 268,
    fill: "#6ee7b7",
    fontSize: 9.5
  }, "Positive")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 283,
    r: 4,
    fill: "#38bdf8",
    opacity: 0.7
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 287,
    fill: "#7dd3fc",
    fontSize: 9.5
  }, "Neutral")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 302,
    r: 4,
    fill: "#f43f5e",
    opacity: 0.8
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 306,
    fill: "#fda4af",
    fontSize: 9.5
  }, "Negative")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 338,
    y1: 218,
    x2: 366,
    y2: 218,
    stroke: "#818cf8",
    strokeWidth: 1.5,
    markerEnd: "url(#ac)"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 211,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "score")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 254 318 L 254 370 L 450 370 L 450 388",
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeDasharray: "4,3",
    markerEnd: "url(#aa)"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 365,
    textAnchor: "middle",
    fill: "#78580a",
    fontSize: 8
  }, "stored for reporting")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 118,
    width: 164,
    height: 200,
    rx: 6,
    fill: "rgba(139,92,246,0.07)",
    stroke: "#8b5cf6",
    strokeWidth: 1.5
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 143,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 12,
    fontWeight: 700
  }, "Prompt")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 159,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 12,
    fontWeight: 700
  }, "Engineering")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 174,
    textAnchor: "middle",
    fill: "#6b4fa0",
    fontSize: 9
  }, "Tone tuned by sentiment")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 181,
    x2: 520,
    y2: 181,
    stroke: "rgba(139,92,246,0.1)",
    strokeWidth: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 205,
    r: 4,
    fill: "#34d399",
    opacity: 0.85
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 209,
    fill: "#6ee7b7",
    fontSize: 9
  }, "Positive \u2192")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 221,
    fill: "#64748b",
    fontSize: 8.5
  }, "  Warm &amp; affirming")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 242,
    r: 4,
    fill: "#38bdf8",
    opacity: 0.7
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 246,
    fill: "#7dd3fc",
    fontSize: 9
  }, "Neutral \u2192")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 258,
    fill: "#64748b",
    fontSize: 8.5
  }, "  Informative")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 279,
    r: 4,
    fill: "#f43f5e",
    opacity: 0.8
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 283,
    fill: "#fda4af",
    fontSize: 9
  }, "Negative \u2192")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 295,
    fill: "#64748b",
    fontSize: 8.5
  }, "  Empathetic &amp; recovery")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 308,
    x2: 520,
    y2: 308,
    stroke: "rgba(139,92,246,0.08)",
    strokeWidth: 1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 532,
    y1: 218,
    x2: 560,
    y2: 218,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#ap)"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 546,
    y: 211,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "prompt")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 562,
    y: 148,
    width: 148,
    height: 140,
    rx: 6,
    fill: "rgba(192,132,252,0.07)",
    stroke: "#c084fc",
    strokeWidth: 1.5
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 173,
    textAnchor: "middle",
    fill: "#c084fc",
    fontSize: 12,
    fontWeight: 700
  }, "OpenAI API")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 189,
    textAnchor: "middle",
    fill: "#7e22ce",
    fontSize: 9
  }, "GPT \xB7 Response generation")), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 574,
    y1: 196,
    x2: 698,
    y2: 196,
    stroke: "rgba(192,132,252,0.1)",
    strokeWidth: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 214,
    r: 3,
    fill: "#c084fc",
    opacity: 0.8
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 588,
    y: 218,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "Structured prompt")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 233,
    r: 3,
    fill: "#c084fc",
    opacity: 0.8
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 588,
    y: 237,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "Tone-aware response")), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 252,
    r: 3,
    fill: "#c084fc",
    opacity: 0.8
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 588,
    y: 256,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "Few seconds / review")), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 574,
    y1: 265,
    x2: 698,
    y2: 265,
    stroke: "rgba(192,132,252,0.08)",
    strokeWidth: 1
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 279,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8.5
  }, "Pilot: hundreds of reviews")), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 710,
    y1: 218,
    x2: 740,
    y2: 218,
    stroke: "#34d399",
    strokeWidth: 1.5,
    markerEnd: "url(#ag)"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 725,
    y: 211,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "output")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 742,
    y: 148,
    width: 140,
    height: 140,
    rx: 6,
    fill: "rgba(52,211,153,0.05)",
    stroke: "#34d399",
    strokeWidth: 1.5
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 812,
    y: 173,
    textAnchor: "middle",
    fill: "#34d399",
    fontSize: 12,
    fontWeight: 700
  }, "Generated")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 812,
    y: 189,
    textAnchor: "middle",
    fill: "#34d399",
    fontSize: 12,
    fontWeight: 700
  }, "Response")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 754,
    y1: 196,
    x2: 870,
    y2: 196,
    stroke: "rgba(52,211,153,0.1)",
    strokeWidth: 1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 758,
    cy: 214,
    r: 3,
    fill: "#34d399",
    opacity: 0.8
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 218,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "Human review")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 231,
    fill: "#475569",
    fontSize: 8.5
  }, "  (pilot validation)")), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 758,
    cy: 248,
    r: 3,
    fill: "#34d399",
    opacity: 0.8
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 252,
    fill: "#6ee7b7",
    fontSize: 9.5
  }, "95%+ usable")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 265,
    fill: "#475569",
    fontSize: 8.5
  }, "  without edits")), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 754,
    y1: 272,
    x2: 870,
    y2: 272,
    stroke: "rgba(52,211,153,0.08)",
    strokeWidth: 1
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 812,
    y: 283,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8.5
  }, "\u2192 Published \u2713")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 390,
    width: 164,
    height: 62,
    rx: 6,
    fill: "rgba(245,158,11,0.05)",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeDasharray: "5,3"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 413,
    textAnchor: "middle",
    fill: "#F59E0B",
    fontSize: 11,
    fontWeight: 700
  }, "Sentiment Store")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 430,
    textAnchor: "middle",
    fill: "#a07020",
    fontSize: 9
  }, "Reporting \xB7 Trend Analysis")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 445,
    textAnchor: "middle",
    fill: "#78580a",
    fontSize: 8.5
  }, "Alerts on high-volume negative reviews")), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 472,
    x2: 42,
    y2: 472,
    stroke: "#818cf8",
    strokeWidth: 2
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 476,
    fill: "#475569",
    fontSize: 9
  }, "Data flow")), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 472,
    x2: 138,
    y2: 472,
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 476,
    fill: "#475569",
    fontSize: 9
  }, "Prompt flow")), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 472,
    x2: 240,
    y2: 472,
    stroke: "#34d399",
    strokeWidth: 2
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 246,
    y: 476,
    fill: "#475569",
    fontSize: 9
  }, "Response output")), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 342,
    y1: 472,
    x2: 362,
    y2: 472,
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeDasharray: "4,2"
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 368,
    y: 476,
    fill: "#475569",
    fontSize: 9
  }, "Sentiment stored (reporting)")), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 472,
    r: 4,
    fill: "#34d399",
    opacity: 0.85
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 476,
    fill: "#475569",
    fontSize: 9
  }, "Positive")), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 472,
    r: 4,
    fill: "#38bdf8",
    opacity: 0.7
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 579,
    y: 476,
    fill: "#475569",
    fontSize: 9
  }, "Neutral")), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 472,
    r: 4,
    fill: "#f43f5e",
    opacity: 0.8
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 476,
    fill: "#475569",
    fontSize: 9
  }, "Negative")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewSentimentPipeline);
export default __webpack_public_path__ + "static/media/review-sentiment-pipeline.b42a59f84b083430d2ca11695404a16a.svg";
export { ForwardRef as ReactComponent };